import Navigation from './navigation';
import InfoButton from '../../info-button';
import {navigate} from '../../../../utils/navigation';

export default () => {

    return (
        <div className="left">
            <div className="logotype" onClick={e => navigate('/')}>
                L<span>ucksy</span>
                {/* <img src={`${window.location.origin}/source/system/halloween/lucksy_halloween_logo.png`} /> */}
                {/* <img src={`${window.location.origin}/source/system/winter/logotype.png`} /> */}
            </div>
            <div className="separator"></div>
            <InfoButton />

            <Navigation />
        </div>
    )
}